import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { AlertType, WOErrorTokens } from '../../common/enums/enums';
import componentToString from '../../helpers/componentToString';
import GenSnackBar from '../GenSnackBar';

export default function WOConstraintsSnackBar({
  error,
  onCleanErrors = () => {},
}) {
  const { t } = useTranslation('global');

  if (!error || error?.token !== WOErrorTokens.SERVICE_LIMIT_EXCEEDED)
    return null;

  const defaultValues = {
    type: AlertType.Error,
    title: t('woErrors.snackBarError'),
    text: (
      <Trans
        t={t}
        i18nKey="woErrors.titles.DAYS_UNTIL_REORDER"
        values={error?.data}
      />
    ),
  };

  const paramsByOverridableAndType = {
    false: {
      DAYS_UNTIL_REORDER: {
        type: AlertType.Error,
        title: t('woErrors.snackBarError'),
        text: (
          <Trans
            t={t}
            i18nKey="woErrors.titles.DAYS_UNTIL_REORDER"
            values={error?.data}
          />
        ),
      },
      MAX_NUMBER_OF_ORDERS: {
        type: AlertType.Error,
        title: t('woErrors.snackBarError'),
        text: (
          <Trans
            t={t}
            i18nKey="woErrors.titles.MAX_NUMBER_OF_ORDERS"
            values={error?.data}
          />
        ),
      },
    },
    true: {},
  };

  const dataByIsOverridable =
    paramsByOverridableAndType[error?.data?.isOverridable] || defaultValues;

  const params = dataByIsOverridable[error?.data?.type] || defaultValues;

  return (
    <GenSnackBar
      open={!!error && error?.token === WOErrorTokens.SERVICE_LIMIT_EXCEEDED}
      onClose={onCleanErrors}
      title={params.title}
      message={componentToString(params.text)}
      type={params.type}
    />
  );
}
